import React, { lazy, Component } from 'react';
import { MapPin, Home, Clock, Smartphone, Package, MessageCircle } from 'lucide-react';
import { WA_NUMBER } from '../data/products';
export function LocationSection() {
  const waLink = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent('Hola! Quiero coordinar un Pick Up para los suplementos')}`;
  return <section className="bg-gradient-to-b from-dark-900 via-dark-700 to-dark-900 py-[80px] px-5" id="ubicacion" data-id="element-180" data-mp="1ddzu5euruzt9">
      <div className="max-w-[1100px] mx-auto" data-id="element-181" data-mp="1n52s47semyob">
        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-white" data-id="element-182" data-mp="1n4ay31egh905">
          Encontranos en AlphaFit
        </h2>
        <p className="text-center text-[#aaa] mb-[50px] text-[1.05rem]" data-id="element-183" data-mp="1x3a5yhred0m3">
          Vení a conocernos o mandanos un WhatsApp antes de venir
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center" data-id="element-184" data-mp="6rcnmzxdi8e5">
          <div data-id="element-185" data-mp="2qam2cfzhk90">
            <h3 className="text-[1.5rem] font-black uppercase tracking-[2px] mb-5 text-alphaGold flex items-center gap-2" data-id="element-186" data-mp="2qkahvldrjcl">
              <MapPin className="w-6 h-6" data-id="element-187" data-mp="2moiu3muuz6i1" /> Nuestra Ubicación
            </h3>

            <div className="flex items-start gap-4 mb-5" data-id="element-188" data-mp="2rq8552i2zk64">
              <Home className="w-6 h-6 text-alphaGold flex-shrink-0 mt-0.5" data-id="element-189" data-mp="2wo9prrv5nrjp" />
              <div data-id="element-190" data-mp="31fhxmjgu74ur">
                <strong className="block text-white text-[0.9rem] uppercase tracking-[1px] mb-1" data-id="element-191" data-mp="31g056c8y95hz">
                  Zona Pick Up
                </strong>
                <span className="text-[#888] text-[0.9rem] leading-[1.6]" data-id="element-192" data-mp="36eb9y8ke0ptc">
                  Malvín, Montevideo, Uruguay
                </span>
              </div>
            </div>

            <div className="flex items-start gap-4 mb-5" data-id="element-193" data-mp="3ffsqtt5mcvj3">
              <Clock className="w-6 h-6 text-alphaGold flex-shrink-0 mt-0.5" data-id="element-194" data-mp="3kevwnftfb5s4" />
              <div data-id="element-195" data-mp="1l18a1rkf5k4z">
                <strong className="block text-white text-[0.9rem] uppercase tracking-[1px] mb-1" data-id="element-196" data-mp="1l1rsd9dzeajj">
                  Horario de Atención
                </strong>
                <span className="text-[#888] text-[0.9rem] leading-[1.6]" data-id="element-197" data-mp="1q2fiztyaspd8">
                  Lunes a Sábados: 10:00 — 18:00 hs
                  <br data-id="element-198" data-mp="1dybjyx1s1n5h" />
                  Domingo: Cerrado
                </span>
              </div>
            </div>

            <div className="flex items-start gap-4 mb-5" data-id="element-199" data-mp="1ry33fdb2bvqv">
              <Smartphone className="w-6 h-6 text-alphaGold flex-shrink-0 mt-0.5" data-id="element-200" data-mp="1rvglqkugjzux" />
              <div data-id="element-201" data-mp="1mxf5e7of2en5">
                <strong className="block text-white text-[0.9rem] uppercase tracking-[1px] mb-1" data-id="element-202" data-mp="20yhr2jbi1mxj">
                  WhatsApp
                </strong>
                <span className="text-[#888] text-[0.9rem] leading-[1.6]" data-id="element-203" data-mp="1ww4lpw0nzr1a">
                  +{WA_NUMBER.substring(0, 3)} {WA_NUMBER.substring(3, 5)}{' '}
                  {WA_NUMBER.substring(5, 8)} {WA_NUMBER.substring(8)}
                </span>
              </div>
            </div>

            <div className="flex items-start gap-4 mb-5" data-id="element-204" data-mp="2klp34ah66g8g">
              <Package className="w-6 h-6 text-alphaGold flex-shrink-0 mt-0.5" data-id="element-205" data-mp="2kk4ef1hjdrii" />
              <div data-id="element-206" data-mp="2flaw8vrb1cc0">
                <strong className="block text-white text-[0.9rem] uppercase tracking-[1px] mb-1" data-id="element-207" data-mp="2z97dnphey52s">
                  Envíos
                </strong>
                <span className="text-[#888] text-[0.9rem] leading-[1.6]" data-id="element-208" data-mp="339hjn257gvhn">
                  Desde $190 UY · Varía según zona de entrega
                </span>
              </div>
            </div>

            <div className="flex flex-wrap gap-2.5 mt-5" data-id="element-209" data-mp="2u91elo8tdgao">
              <a href="https://www.google.com/maps/search/Malvín+Montevideo+Uruguay" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-transparent border-2 border-alphaGold text-alphaGold text-[0.85rem] font-extrabold py-3 px-6 rounded uppercase tracking-[1px] transition-colors duration-300 hover:bg-alphaGold hover:text-white" data-id="element-210" data-mp="2fl7zs5rjyht5">
                <MapPin className="w-4 h-4" data-id="element-211" data-mp="1wnnbazsp9l92" /> Ver en Google Maps
              </a>
              <a href={waLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-transparent border-2 border-alphaGold text-alphaGold text-[0.85rem] font-extrabold py-3 px-6 rounded uppercase tracking-[1px] transition-colors duration-300 hover:bg-alphaGold hover:text-white" data-id="element-212" data-mp="21kdrdn4i8guh">
                <MessageCircle className="w-4 h-4" data-id="element-213" data-mp="2q885jgpwqc3f" /> WhatsApp
              </a>
            </div>
          </div>

          <div data-id="element-214" data-mp="2l9epbgj8k6zk">
            <div className="rounded-lg overflow-hidden border-2 border-alphaGold h-[320px]" data-id="element-215" data-mp="2l9wvb4vp9zko">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26186.416246419514!2d-56.11776510309653!3d-34.88725176506456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x959f81216503b081%3A0x8681b9e2c6598c0b!2sMalv%C3%ADn%2C%20Montevideo%2C%20Departamento%20de%20Montevideo!5e0!3m2!1ses!2suy!4v1700000000000!5m2!1ses!2suy" allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="AlphaFit - Malvín, Montevideo" className="w-full h-full border-none" data-id="element-216" data-mp="2h570ljcs2r1c"></iframe>
            </div>
            <p className="text-[#555] text-[0.8rem] mt-2.5 text-center" data-id="element-217" data-mp="mqjoiv3kar5y">
              Hacé click en el mapa para abrir en Google Maps y obtener
              indicaciones
            </p>
          </div>
        </div>
      </div>
    </section>;
}